import * as React from 'react';
import { PropsWithChildren } from 'react';

import { Loader } from '../Loader';

import { ButtonArgs } from './index';
import { BtnText, CenteredLoaderBox, IconBox, StyledButton } from './styles';

export const Button = ({
    onClick,
    backgroundColor,
    textColor,
    hoverColor,
    activeColor,
    size = 'medium',
    disabled = false,
    isLoading = false,
    withPulsating = false,
    children,
    rightIcon,
    centerIcon,
    dataLocator,
    borderRadius = 'medium',
    className,
    mb,
    textStyle,
    type,
    dataTestId = 'button',
}: PropsWithChildren<ButtonArgs>) => {
    const getBtnTextStyle = () => {
        if (textStyle) {
            return textStyle;
        }

        if (size === 'medium') {
            return 'medium-button';
        }

        if (size === 'small') {
            return 'small-button';
        }

        return 'medium-button';
    };

    return (
        <StyledButton
            onClick={onClick}
            $backgroundColor={backgroundColor}
            $textColor={textColor}
            $hoverColor={hoverColor}
            $activeColor={activeColor}
            $size={size}
            disabled={disabled || isLoading}
            $isLoading={isLoading}
            $withPulsating={withPulsating}
            $rightIcon={rightIcon}
            $centerIcon={centerIcon}
            $borderRadius={borderRadius}
            className={className}
            data-locator={dataLocator}
            $mb={mb}
            type={type}
            data-testid={dataTestId}
        >
            {isLoading && (
                <CenteredLoaderBox data-testid="button-loader">
                    <Loader size={28} color={textColor} />
                </CenteredLoaderBox>
            )}
            {!isLoading && rightIcon && (
                <IconBox>
                    <BtnText type={size === 'medium' ? 'medium-button' : 'small-button'} $textColor={textColor}>
                        {children}
                    </BtnText>
                    <img src={rightIcon} alt="icon" />
                </IconBox>
            )}
            {!isLoading &&
                !rightIcon &&
                (centerIcon ? (
                    <IconBox isCenter>
                        <BtnText type={getBtnTextStyle()} $textColor={textColor}>
                            {children}
                        </BtnText>
                        <img src={centerIcon} alt="icon" />
                    </IconBox>
                ) : (
                    <BtnText type={getBtnTextStyle()} $textColor={textColor}>
                        {children}
                    </BtnText>
                ))}
        </StyledButton>
    );
};
